"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("@material-ui/icons");

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Button = _interopRequireDefault(require("../Button"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    popover: {
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(1)
    },
    helperButton: {
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(0.8)
    }
  };
});

var PopoverButton = function PopoverButton(props) {
  var id = props.id,
      popoverText = props.popoverText,
      customHelperIcon = props.customHelperIcon;

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var classes = useStyles(props);
  if (!popoverText) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "icon",
    className: (0, _classnames.default)("prmbl-icon-button", classes.helperButton),
    onClick: handleClick,
    "aria-owns": anchorEl ? "mouse-over-popover" : undefined,
    "aria-haspopup": "true",
    "aria-label": "Get additional help",
    size: "small",
    color: anchorEl ? "primary" : "default"
  }, customHelperIcon ? customHelperIcon : /*#__PURE__*/_react.default.createElement(_icons.InfoOutlined, {
    className: (0, _classnames.default)("prmbl-formLabel-icon-svg"),
    fontSize: "small"
  })), /*#__PURE__*/_react.default.createElement(_Popover.default, {
    "data-testid": "popover",
    id: "".concat(id, "-popover"),
    className: (0, _classnames.default)("prmbl-popover", classes.popover),
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "bottom",
      horizontal: "center"
    }
  }, popoverText));
};

var _default = PopoverButton;
exports.default = _default;